import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import Editor from './Editor';

export default createTaskType({
    id: 'comic_story',
	label: 'Comic Story',
    skill: 'reading_writing',
    v2: true,
    hasRubric: true,

    backgroundImages: { count: 1 },

    editor: Editor,
    createItemsTemplate: () => [
        ...times(7, createPhase1Item),
        ...times(2, createPhase2Item)
    ],

    convertToLocalFormat(task) {
        task.items = task.items.map(item => {
            const groupParts = item.group?.split('GROUP_') ?? [];
            item.group = groupParts.length === 2 ? parseInt(groupParts[1]) : null;
            return item;
        })
        return task;
    },

    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);

        // NB: Backend incorrectly has a second bg image field, but allows null.
        if (isNew) {
            task.background_image_2 = null;
        } else {
            delete task.background_image_2;
        }

        task.items = task.items.map(item => ({
            ...item,
            // These must be null rather than empty
            stimulus_text: item.stimulus_text?.length >= 1 ? item.stimulus_text : null,
            question_1: item.question_1 || null,
            question_2: item.question_2 || null,
            speech_bubble_1: item.speech_bubble_1 || null,
            speech_bubble_2: item.speech_bubble_2 || null,
            /*
            BE requires them to be objects.
            speech_bubble_1_coordinates: !!item.speech_bubble_1 ? item.speech_bubble_1_coordinates : null,
            speech_bubble_2_coordinates: !!item.speech_bubble_2 ? item.speech_bubble_2_coordinates : null,
            */
            group: !!item.group ? `GROUP_${item.group}` : null,
            answers: item.answers.map(answer => {
                if (typeof answer.key === 'string') {
                    answer.key = answer.key.split(',').map(x => x.trim()).filter(x => !!x);
                }
                if (typeof answer.training_sentences === 'string') {
                    answer.training_sentences = answer.training_sentences.split(',').map(x => x.trim()).filter(x => !!x);
                }
                return answer;
            })
        }));
        return task;
    },

    getKeys: (item) => {
        return item.answers.filter(x => x.is_correct_answer).map(x => x.key.join(', '));
    }
});

function createPhase1Item(index) {
    return {
        phase: 'PHASE_1',
        is_example: index === 0,
        is_capital: false,
        ...(index === 0 && { rubric_id: '' }),

        group: Math.floor(Math.max(index - 1, 0) / 2) + 1,

        stimulus_text: '',
        question_1: '',
        question_2: '',
        speech_bubble_1: '',
        speech_bubble_1_coordinates: {
            top: 0,
            left: 0
        },
        speech_bubble_2: '',
        speech_bubble_2_coordinates: {
            top: 0,
            left: 0
        },

        answers: [{
            is_correct_answer: true,
            key: [],
        }],
    }
}

function createPhase2Item(index) {
    return {
        phase: 'PHASE_2',
        is_example: false,
        is_capital: false,
        ...(index === 7 && { rubric_id: '' }),
        answers: times(3, () => ({
            is_correct_answer: true,  // backend required a value to be set.
            image_id: '',
            key: [],
            training_sentences: []
        })),
    }
}